import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getConfig } from "Config";

const root = ReactDOM.createRoot(document.getElementById("root"));
const { GoogleOAuthID, environment } = getConfig();
const hasGoogleOAuthId = Boolean(
  GoogleOAuthID && GoogleOAuthID !== "undefined" && GoogleOAuthID !== "null",
);

if (!hasGoogleOAuthId && environment !== "production") {
  console.warn(
    "Missing REACT_APP_GOOGLE_OAUTH_ID. Google login will be disabled.",
  );
}

const appTree = (
  <BrowserRouter>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </BrowserRouter>
);

root.render(
  <React.StrictMode>
    {hasGoogleOAuthId ? (
      <GoogleOAuthProvider clientId={GoogleOAuthID}>
        {appTree}
      </GoogleOAuthProvider>
    ) : (
      appTree
    )}
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
